import { render, staticRenderFns } from "./AssetPackage.vue?vue&type=template&id=13dc72cf&scoped=true"
import script from "./AssetPackage.vue?vue&type=script&lang=js"
export * from "./AssetPackage.vue?vue&type=script&lang=js"
import style0 from "./AssetPackage.vue?vue&type=style&index=0&id=13dc72cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dc72cf",
  null
  
)

export default component.exports